module.exports = __webpack_public_path__ + "static/media/ZWZ_China.0be19eaf.png";